import React, { ElementType, useCallback, useEffect, useState } from "react";
import {
	CommonPropertyProps,
	ElementSchema,
	ElementTypeList,
	NumberFormat,
	NumberFormatRules,
} from "schemas/elements";
import elementsSchema from "schemas";
import { NumberFormatMap } from "../properties";
import { v4 as uuidv4 } from "uuid";
import { Button, Elem, ElemBefore, IconButton } from "@alm/flow-ds/components";
import { useTranslation } from "react-i18next";

type numberFormatProps = "precision" | "rounding";

type numberFormatPropertyTypes = "number" | "string";

type Props = Omit<CommonPropertyProps, "value"> & {
	elem: string;
	value: NumberFormat;
};

export default ({
	updateStore,
	field,
	required,
	value,
	desc,
	validation,
	elementIndex,
	elem,
}: Props) => {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);
	const props = {
		updateStore,
		field,
		required,
		elementIndex,
		validation,
		value: { ...value },
	};
	const myElementSchema: ElementSchema = elementsSchema as ElementSchema;
	// looks for the element in the schema to get the props it needs for later
	const numberFormatElement: NumberFormatRules =
		myElementSchema[elem as ElementTypeList].numberFormat.rules;

	const handleRemove = useCallback(() => {
		setOpen(false);
		updateStore({
			elementIndex,
			property: field,
			value: {},
		});
	}, [elementIndex, field, updateStore]);

	/**
	 * Opens number format to user on mount if it is filled
	 */
	useEffect(() => {
		if (
			value?.precision !== undefined ||
			(value?.rounding !== undefined && value?.rounding !== null)
		)
			setOpen(true);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return (
		<Elem className="elem-twin-input">
			<ElemBefore label={t(`formDesigner.properties.${field}`)} />
			<div className="hint-text">
				{t(`formDesigner.elements.${desc}`)}
			</div>

			<div className="elem-twin-input-properties">
				{open ? (
					<div className="elem-twin-input-item" key={1}>
						{Object.keys(numberFormatElement).map(property => {
							const theProperty = property as numberFormatProps;
							const theObject = numberFormatElement[theProperty];
							const Property: ElementType =
								NumberFormatMap[
									theObject.type as numberFormatPropertyTypes
								];
							const id: string = uuidv4();
							return (
								<Property
									key={theProperty}
									{...props}
									id={id}
									nextProp={property}
									desc={theObject?.desc}
									required={theObject?.required}
									options={
										theProperty === "rounding"
											? [
													{
														value: "up",
														label: "Up",
													},
													{
														value: "down",
														label: "Down",
													},
													{
														value: "halfUp",
														label: "Half Up",
													},
													{
														value: "halfDown",
														label: "Half Down",
													},
											  ]
											: undefined
									}
								/>
							);
						})}
						<IconButton
							label={t("formDesigner.labels.remove")}
							icon="times"
							onClick={handleRemove}
							className="btn-outline-danger number-format"
						/>
					</div>
				) : (
					<Button
						label={t("formDesigner.labels.add")}
						onClick={() => setOpen(true)}
						className="btn-default"
					/>
				)}
			</div>
		</Elem>
	);
};
